<template>
  <div
    class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0"
  >
    <BannerNotification />
    <SDNComponentCreateHeader
      :title="componentName"
      :handleCreate="handleCreateInstance"
    />
    <SDNComponentCreateForm
      :elementName="elementName"
      :formData="formData"
      :attributesCategory="attributesCategory"
      :componentId="componentId"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";
import BannerNotification from "@/components/Shared/Notification/BannerNotification";
import SDNComponentCreateHeader from "@/components/ComponentModule/SpecialDynamicNumComponent/SDNComponentCreateHeader";
import SDNComponentCreateForm from "@/components/ComponentModule/SpecialDynamicNumComponent/SDNComponentCreateForm";

export default {
  name: "SDNComponentCreatePage",
  components: {
    BannerNotification,
    SDNComponentCreateHeader,
    SDNComponentCreateForm
  },
  data() {
    return {
      formData: { attributes: {}, instance_name: "" }
    };
  },
  async mounted() {
    await this.$store.dispatch(Actions.FETCH_COMPONENT_DATA, {
      region: this.getRegion,
      componentId: this.componentId
    });
  },
  props: {
    elementName: {
      type: String,
      required: true
    },
    componentId: {
      type: String,
      required: true
    },
    attributesCategory: {
      type: Object,
      required: true
    }
  },
  computed: {
    componentName() {
      if (
        this.getAllComponent.find(
          (item) => item.id === this.$route.params.compId
        )
      ) {
        return this.getAllComponent.find(
          (item) => item.id === this.$route.params.compId
        ).name;
      } else {
        return "";
      }
    },
    ...mapGetters(["getAllComponent", "getRegion"])
  },
  methods: {
    handleCreateInstance() {
      this.$store
        .dispatch(Actions.CREATE_COMPONENT_DATA, {
          formData: this.formData,
          region: this.getRegion,
          componentId: this.$route.params.compId
        })
        .then(() => {
          this.$router.push(`/component/${this.$route.params.compId}`);
        });
    }
  }
};
</script>
